import type {
    WebSkillListParams,
    WebSkillListResponse,
    WebSkillDetailItem,
    WebSkillCreateRequest,
    WebSkillCreateData,
    WebSkillEnableData,
    WebSkillDeleteData,
    WebSkillUpdateRequest,
    WebSkillUpdateData,
    WebSkillImportRequest,
    WebSkillImportData,
    WebSkillSecurityCheckRequest,
    SkillSecurityCheckData,
} from '../types';

export const SkillApiService = Symbol('SkillApiService');

export interface SkillApiService {
    getList(params?: WebSkillListParams): Promise<WebSkillListResponse>;
    getDetail(id: string): Promise<WebSkillDetailItem>;
    create(data: WebSkillCreateRequest): Promise<WebSkillCreateData>;
    update(id: string, data: WebSkillUpdateRequest): Promise<WebSkillUpdateData>;
    enable(id: string): Promise<WebSkillEnableData>;
    disable(id: string): Promise<WebSkillEnableData>;
    remove(id: string): Promise<WebSkillDeleteData>;
    exportSkill(id: string): Promise<Blob>;
    importSkill(data: WebSkillImportRequest): Promise<WebSkillImportData>;
    validateImportSecurity(data: WebSkillSecurityCheckRequest): Promise<SkillSecurityCheckData>;
}
